<template>
  <!-- 删除遮罩层 -->
  <div class="del-pop">
    <el-dialog
      :visible.sync="delVisible"
      :close-on-click-modal="false"
      :show-close="false"
      center
      width="23%"
      top="300px"
    >
      <div
        slot="title"
        class="dialog-title"
      >
        <div class="logo">
          <i class="el-icon-delete-solid"></i>
        </div>
      </div>
      <span>删除不可撤销 , 确认删除？</span>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          class="dialog-but"
          @click="cancel"
        >取 消</el-button>
        <el-button
          class="dialog-but"
          type="danger"
          @click="go"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>

</template>
<script>
export default {
  props: {
    delVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  methods: {
    cancel () {
      this.$emit('close', false)
    },
    go () {
      this.$emit('close', true)
    }
  }
}
</script>

<style lang="less" scoped>
.del-pop {
  /deep/.el-dialog--center {
    border-radius: 8px;
  }
  /deep/.el-dialog__header {
    padding: 0px;
    .dialog-title {
      position: relative;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 10px;
      background: #f56c6c;
      border-radius: 8px 8px 0px 0px;
      margin-bottom: 45px;
      .logo {
        transform: translate(-50%, -50%);
        position: absolute;
        top: 50%;
        left: 50%;
        width: 78px;
        height: 78px;
        border-radius: 50%;
        background: #f56c6c;
        color: #fff;
        font-size: 50px;
      }
    }
  }
  /deep/.el-dialog--center .el-dialog__body {
    font-weight: 700;
    text-align: center;
    padding: 25px 25px 30px;
    color: #000;
    font-size: 15px;
  }
  .dialog-but {
    border: 1px solid rgb(236, 227, 227);
    width: 120px;
    margin-bottom: 20px;
  }
}
</style>
